<div appStickyHeader class="pos-rel-header" [animate]="config?.animateHeader" [class]="config?.headerClass || 'topsticky'" [ngClass]="isSticky">
  <header id="navbar" class="d-none d-lg-block">
    <div id="navUpdates">
      <div class="container">
        <div class="top desktop-menus">
          <div [hidden]="!utilService.logoUrlDark" class="logo float-left">
            <a [routerLink]="'/'" queryParamsHandling="merge" [ngClass]="{'no-event': !config?.logoNavigate}">
              <img class="brand-logo" [src]="utilService.logoUrlDark" alt="ngo" />
            </a>
          </div>
          <div class="flex-menus">
            <div class="login-menu">
              <span class="menu-spacer"></span>
              <a *ngIf="config?.showCurrency" href="javascript:void(0)" class="currency-switcher">
                <ng-template [ngTemplateOutlet]="currencyDropdown"></ng-template>
              </a>
              <div class="secure-tag">
                <img src="/assets/images/story/icon-secure-lock.png" alt="secure lock" />
                <div class="secure-txt">100% Secure</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</div>

<header id="navbar" class="d-lg-none {{config?.headerClass}} {{isSticky}}">
  <div class="menus">
    <mat-sidenav-container class="nav-container">
      <mat-sidenav-content class="mobile-header pos-rel-header" appStickyHeader [animate]="config?.animateHeader" [class]="config?.headerClass || 'topsticky'" [ngClass]="isSticky">
        <div *ngIf="utilService.logoUrlDark" class="logo float-left">
          <a [href]="utilService.domain_details?.domain_url">
            <img [src]="utilService.logoUrlDark" alt="ngo" height="45" />
          </a>
        </div>
        <a *ngIf="config?.showCurrency" href="javascript:void(0)" class="currency-anchor" [ngClass]="{'c-right': !config?.showProfile}">
          <ng-template [ngTemplateOutlet]="currencyDropdown"></ng-template>
        </a>
      </mat-sidenav-content>
    </mat-sidenav-container>
  </div>
</header>

<!-- Currency dropdown template -->
<ng-template #currencyDropdown>
  <span class="d-lg-block d-md-block d-none">
    <mat-chip-list>
      <mat-chip class="toolbar-currency" [matMenuTriggerFor]="currencyMenu">
        <div class="icon-size" [innerHTML]="currencySymbol"></div>
        <mat-icon>arrow_drop_down</mat-icon>
      </mat-chip>
    </mat-chip-list>
    <mat-menu #currencyMenu="matMenu" class="menu">
      <div *ngFor="let item of countries">
        <button class="menu-item" mat-menu-item (click)="setCurrencyFromMenu(item)">
          <span class="icon-size" [innerHTML]="item?.symbol"></span>
        </button>
      </div>
    </mat-menu>
  </span>
  <mat-chip-list class="d-lg-none d-md-none d-block">
    <mat-chip class="currency-chip toolbar-currency">
      <select class="currency-select" (change)="setCurrencyFromMenu($event, 'select')" [(ngModel)]="currency">
        <option *ngFor="let item of countries" [value]="item?.currency" [selected]="currency==item?.currency">
          <span class="icon-size" [innerHTML]="item?.symbol"></span>
        </option>
      </select>
      <mat-icon class="icon">arrow_drop_down</mat-icon>
    </mat-chip>
  </mat-chip-list>
</ng-template>